<template>
  <div class="pa-0 ma-0">
    <v-data-table
      :headers="headers"
      :items="providers"
      :hide-default-footer="true"
      :no-data-text="$t('Generic.No_Data')"
      class="elevation-0"
      dense
    >
      <template v-slot:item.name="{ item }">
        <v-text-field
          :placeholder="$t('Generic.Name')"
          v-model="item.name"
          :rules="[v => !!v || $t('Rules.Name_required')]"
        ></v-text-field>
      </template>

      <template v-slot:item.apiSiteId="{ item }"
        ><v-text-field
          :placeholder="$t('Manage_Sites.SiteId')"
          v-model="item.apiSiteId"
          :rules="[v => !!v || $t('Rules.SiteId_required')]"
        ></v-text-field>
      </template>

      <template v-slot:item.apiKey="{ item }">
        <v-text-field
          v-if="!item.id || !!item.apiKey"
          :placeholder="$t('Manage_Sites.APIKey')"
          v-model="item.apiKey"
          :rules="[v => !!v || $t('Rules.APIKey_required')]"
        ></v-text-field>
        <v-btn
          v-else
          text
          small
          color="primary"
          class="ma-0 pa-0 text-none"
          v-on:click="fetchApiKey(item)"
        >
          {{ obfuscatedApiKey }}
        </v-btn>
      </template>

      <template v-slot:item.Actions="{ item }">
        <v-btn
          v-if="!!item.apiKey"
          small
          text
          icon
          color="blue"
          class="ma-0 pa-0"
          v-on:click="downloadDTA(item)"
        >
          <v-icon small class="ma-0 pa-0">
            mdi-file-download
          </v-icon>
        </v-btn>
        <v-btn
          text
          icon
          color="red"
          class="ma-0 pa-0"
          v-on:click="removeProvider(item)"
        >
          <v-icon class="ma-0 pa-0">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-btn class="mt-2" rounded depressed small v-on:click="addProvider">
      <v-icon color="primary" class="pr-1">mdi-plus</v-icon>
      {{ $t("Manage_Sites.SiteProvidersTable.AddProvider") }}
    </v-btn>
  </div>
</template>
<script>
import DTAGenerationHelper from "@/helpers/DTAGenerationHelper";
import SiteService from "@/services/SiteService";

export default {
  data() {
    return {
      obfuscatedApiKey: "********",
      headers: [
        {
          text: this.$i18n.t("Generic.Name"),
          align: "left",
          value: "name",
          sortable: false
        },
        {
          text: this.$i18n.t("Manage_Sites.SiteId"),
          align: "left",
          value: "apiSiteId",
          sortable: false
        },
        {
          text: this.$i18n.t("Manage_Sites.APIKey"),
          align: "left",
          value: "apiKey",
          sortable: false
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ]
    };
  },
  props: {
    providers: Array,
    siteName: String
  },
  methods: {
    removeProvider(provider) {
      const index = this.providers.indexOf(provider);
      if (index !== -1) {
        this.providers.splice(index, 1);
      }
    },
    addProvider() {
      this.providers.push({
        name: "",
        apiSiteId: ""
      });
    },
    fetchApiKey(provider) {
      if (!provider?.id) {
        return;
      }

      SiteService.GetProviderApiKey(provider.id).then(response => {
        const fetchedApiKey =
          response?.data?.apiKey || response?.data?.key || response?.data;
        this.$set(provider, "apiKey", fetchedApiKey || "");
        this.$emit("provider-api-key-fetched", {
          providerId: provider.id,
          apiKey: fetchedApiKey || ""
        });
      });
    },
    downloadDTA(provider) {
      if (!provider.apiKey) {
        return;
      }

      DTAGenerationHelper.DownloadDTA({
        name: this.siteName,
        apikey: provider.apiKey,
        siteId: provider.apiSiteId
      });
    }
  }
};
</script>
